export enum IRCATicketTypeEnum {
    RCA = "rca",
    ACTION_PLAN = "actionPlan",
    ISSUE = "issue",
}

export interface IRCATicketNumber {
    ticketNumber: string;
    ticketType: IRCATicketTypeEnum;
    className?: string;
}
